<template>
  <div
    class="safety-drop"
    :class="{ 'safety-drop--inactive': !active }"
    v-clickoutside="onBlur"
  >
    <label class="safety-drop__head">{{ label }}</label>
    <div
      class="safety-drop__body"
      :class="{ 'safety-drop__body--opened': opened }"
      :tabindex="active ? '0' : '-1'"
      @click="onClick"
      @keydown.enter.prevent="onClick"
    >
      <div class="safety-drop__body-button">
        <div class="safety-drop__body-button-text">{{ text }}</div>
      </div>
      <div class="safety-drop__body-content">
        <li
          tabindex="0"
          class="safety-drop__body-content-option"
          v-for="item in items"
          :key="item.id"
          @click="onSelect(item)"
          @keydown.enter.prevent="onSelect(item)"
        >
          {{ getName(item) }}
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import { values } from 'lodash'

export default {
  name: 'SafetyDrop',
  props: ['name', 'label', 'items', 'selected', 'active', 'toStep'],
  data() {
    return {
      opened: false,
      item: null,
    }
  },
  computed: {
    text() {
      return this.item ? this.getName(this.item) : this.selected
    },
  },
  methods: {
    onClick() {
      if (!this.active) {
        return
      }
      this.opened = !this.opened
    },
    getName(item) {
      return values(item)[0].Title
    },
    clearSelection() {
      this.item = null
      this.emitChanged(null)
    },
    onBlur() {
      const self = this
      setTimeout(() => {
        self.opened = false
      }, 250)
    },
    onSelect(item) {
      this.item = item
      this.emitChanged(item)
    },
    emitChanged(newValue) {
      this.$emit('changed', newValue)
    }
  }
}
</script>
